import React, { useState } from "react";
import "./OverView.css";
import "./UseCaseSlider.css";

const data = [
  {
    title: "Digital Solutions",
    answer: [
      "Explore digital solutions such as Computerized Maintenance Management Systems (CMMS), Enterprise Asset Management (EAM) software and Internet of Things (IoT) sensors. These technologies enable real-time asset monitoring, automated data collection and advanced analytics for better decision-making.",
    ],
  },
  {
    title: "Energy & Utilities",
    answer: [
      "Power generation assets, electrical grid assets, renewable energy assets, energy storage systems, HVAC and building systems, industrial equipment and more.",
      "Transmission and distribution of electric power requires capabilities for linear assets like power lines. ",
    ],
  },
  {
    title: "Government",
    answer: [
      "Public buildings, and utility fleets for drinking water, sewer services, electricity and solid waste management, along with the specialized vehicles and infrastructure behind them.",
      "Emergency vehicles like ambulances, fire trucks and police cars must always be mission-ready. Maintenance and replacement planning keeps a steady rotation of first-responder vehicles.",
      "Local governments own diverse land assets like parks, trails and undeveloped properties. While less complex than infrastructure, open spaces still need tracking and upkeep as public resources.",
      // "Municipal infrastructure maintains key utility services that see day-to-day use by citizens and visitors: roads, rail lines, bridges, water pipes, sewer mains, storm drains, traffic signals, security cameras and more.",
    ],
  },
  {
    title: "Healthcare",
    answer: [
      "Healthcare EAM solutions must manage complex relationships between facilities and equipment readiness. They track and locate critical assets, monitor facility conditions, comply with reporting requirements and integrate with operational health information systems.",
    ],
  },
  {
    title: "Manufacturing",
    answer: [
      "Asset tracking and documentation, preventive and predictive maintenance, data-driven decision making, employee training and engagement, integration with technology and more.",
      "Manufacturing includes an array of sectors: automotive, aerospace, defense, electronics, industrial products, consumer products and more. In these contexts, EAM systems become part of overall process management methodologies such as Lean Six Sigma and complement product lifecycle management requirements.",
    ],
  },
  {
    title: "Mining & Heavy Machines",
    answer: [
      "Equipment and machinery like excavators, haul trucks, bulldozers, power drills, crushers and conveyor systems.",
      "Real-time monitoring of the location, performance and safety of all assets is critical to streamline processes, eliminate downtime, reduce costs and minimize environmental impact. With the right system you can track asset maintenance history, asset movements and more.",
      "These industries emphasize integrating safety, reliability, compliance and performance into workflows. EAM systems help reduce costs by standardizing and improving maintenance practices and fostering collaboration.",
    ],
  },
  {
    title: "Travel & Transportation",
    answer: [
      "Transit agencies, whether they manage airplanes, cars, trucks, buses, trains or infrastructure, depend on complex, high-performing transportation assets to keep the world moving. Efficiently monitoring, managing and maintaining these assets while controlling costs enhances everyone’s safety.",
      "The focus is on providing details about assets and inventory that enable a service or logistics function. Fuel management, driver logs, spare parts, bay schedules and other data are critical to maintaining rail, road and air traffic operations.",
    ],
  },
];

const UseCaseSlider = () => {
  const [selected, setSelected] = useState(0);
  const current = data[selected];

  return (
    <section
      className="WhyAM mx-auto w-full max-w-[110rem] px-5 sm:px-14 font-['Poppins',sans-serif]"
      id="UseCase"
    >
      {/* <div className="inline-block rounded-full bg-[#002C78]/10 px-4 py-1 text-xs font-semibold uppercase tracking-wider text-[#002C78] mb-4">
        Industry Applications
      </div> */}
      <h2 className="mb-4 text-3xl sm:text-4xl lg:text-[2.6rem] font-bold leading-tight text-[#002C78]">
        Use Cases
      </h2>
      <div className="w-24 h-1 bg-[#002C78] mb-12 sm:mb-16"></div>

      <div className="flex flex-col gap-8 lg:flex-row lg:gap-14">
        <nav aria-label="Industries" className="lg:w-[22rem] lg:shrink-0">
          <ul className="am-uc-list m-0 list-none p-0">
            {data.map((item, i) => (
              <li key={item.title}>
                <button
                  type="button"
                  className="am-uc-tab w-full"
                  aria-pressed={selected === i}
                  onClick={() => setSelected(i)}
                >
                  <span className="am-uc-num">
                    {String(i + 1).padStart(2, "0")}
                  </span>
                  <span>{item.title}</span>
                </button>
              </li>
            ))}
          </ul>
        </nav>

        {/* key forces the fade animation to replay on every change */}
        <div
          key={current.title}
          className="am-uc-panel min-w-0 flex-1 rounded-2xl bg-white p-8 sm:p-12"
          aria-live="polite"
        >
          <div className="flex items-center gap-3 mb-4">
            <span className="inline-block rounded-full bg-[#002C78]/10 px-3 py-1 text-xs font-semibold text-[#002C78]">
              {String(selected + 1).padStart(2, "0")} of {String(data.length).padStart(2, "0")}
            </span>
            <span className="text-sm font-semibold uppercase tracking-wider text-[#F23100]">
              Industry Focus
            </span>
          </div>

          <h3 className="mb-6 text-2xl sm:text-3xl font-bold leading-snug text-[#002C78]">
            {current.title}
          </h3>
          <div className="flex max-w-[70ch] flex-col gap-5 text-[1.08rem] leading-[1.85] text-[#4b5563]">
            {current.answer.map((para, i) => (
              <p key={i}>{para}</p>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default UseCaseSlider;
